import { Injectable } from '@angular/core';
import { HttpServiceParent } from './httpServiceParent';
import { HttpClient } from '@angular/common/http';
import { ReportRequest } from './request/report-request';
import { StaffOrganisationReportRow } from '../domain/corporate/staff-organisation-report';
import { TaskOrganisationGroupReportRow } from '../domain/corporate/task-group-report';
import { environment } from '../../environments/environment';
import { AuditReportRecord } from '../domain/audit-report-record';
import { PortfolioReportRecord } from '../domain/portfolio-report-record';
import { DataTaskChart } from '../domain/data-task-chart';
import { DataStaffChart } from '../domain/data-staff-chart';
import { PropertyStoreService } from './stores/property-store.service';
import { Observable } from 'rxjs';
import { TaskOrganisationReportRow } from '../domain/corporate/task-organisation-report-row';

@Injectable({
   providedIn: 'root'
})
export class ReportService extends HttpServiceParent {
   constructor(
      private http: HttpClient,
      private propertyStore: PropertyStoreService
   ) {
      super(propertyStore);
   }

   private convertReportRequestDates(request: ReportRequest): ReportRequest {
      if (request.start) {
         request.start = this.getDateStringForApiQueryFromDateString(request.start);
      }
      if (request.finish) {
         request.finish = this.getDateStringForApiQueryFromDateString(request.finish);
      }
      return request;
   }

   getAuditReport(propId: number, request: ReportRequest) {
      return this.http.post<AuditReportRecord[]>(
         `${environment.apiEndpoint}/report/audit/property/${encodeURIComponent(
            propId
         )}`,
         this.convertReportRequestDates(request),
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }

   getFormAuditReport(propId: number, request: ReportRequest) {
      return this.http.post<AuditReportRecord[]>(
         `${
            environment.apiEndpoint
         }/report/audit/form/property/${encodeURIComponent(propId)}`,
         this.convertReportRequestDates(request),
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }

   getPortfolioReport(request: ReportRequest) {
      return this.http.post<PortfolioReportRecord[]>(
         `${environment.apiEndpoint}/report/portfolio`,
         this.convertReportRequestDates(request),
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }

   getTaskReport(propId: number, request: ReportRequest) {
      return this.http.post<DataTaskChart[]>(
         `${environment.apiEndpoint}/report/task/property/${encodeURIComponent(
            propId
         )}`,
         this.convertReportRequestDates(request),
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }

   getStaffReport(propId: number, request: ReportRequest) {
      return this.http.post<DataStaffChart[]>(
         `${environment.apiEndpoint}/report/staff/property/${encodeURIComponent(
            propId
         )}`,
         this.convertReportRequestDates(request),
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }

   getOrganisationStaffReport(
      organisationId: number,
      request: ReportRequest
   ): Observable<StaffOrganisationReportRow[]> {
      return this.http.post<StaffOrganisationReportRow[]>(
         `${environment.apiEndpoint}/report/staff/organisation/${encodeURIComponent(organisationId)}`,
         request
      );
   }

   getOrganisationTaskGroupReport(
      organisationId: number,
      request: ReportRequest
   ): Observable<TaskOrganisationGroupReportRow[]> {
      return this.http.post<TaskOrganisationGroupReportRow[]>(
         `${environment.apiEndpoint}/report/task/organisation/${encodeURIComponent(organisationId)}/group`,
         request
      );
   }

   getOrganisationTaskReport(
      organisationId: number,
      request: ReportRequest
   ): Observable<TaskOrganisationReportRow[]> {
      return this.http.post<TaskOrganisationReportRow[]>(
         `${environment.apiEndpoint}/report/task/organisation/${encodeURIComponent(
            organisationId
         )}`,
         this.convertReportRequestDates(request),
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }
}
